import type { PagePayload } from '../types/pagePayload';

/** Collection-backed content is isolated from legacy page/global content.
 * Keep the collection keys present as empty arrays when no entries are published,
 * so a template cannot mistake an absent key for permission to use seed data.
 */
const COLLECTION_KEYS = ['programmes', 'testimonials', 'articles', 'staff'] as const;

type CollectionEntry = Record<string, unknown>;

export function isolateCollectionPayload(payload: PagePayload): PagePayload {
  const collections: Record<string, CollectionEntry[]> = { ...payload.collections };
  const globalContent = { ...payload.globalContent };
  const content = { ...payload.content };

  for (const key of COLLECTION_KEYS) {
    const entries = collections[key];
    collections[key] = Array.isArray(entries) ? entries : [];
    delete globalContent[key];
    // `staff` is also an About-page content object containing philosophy copy,
    // portrait images, and instructor section labels. Keep this page-owned
    // object while isolating published staff profiles in collections.staff.
    if (key !== "staff") delete content[key];
  }

  return { ...payload, content, globalContent, collections };
}
